import { render, staticRenderFns } from "./project-avatar.component.vue?vue&type=template&id=004f24a7&"
import script from "./project-avatar.component.vue?vue&type=script&lang=ts&"
export * from "./project-avatar.component.vue?vue&type=script&lang=ts&"
import style0 from "./project-avatar.component.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports